define('modules/common/controller/Dashboard',[], function() {
	var Controller = function(
		$scope,
		$state,
		Token,
		DatiCliente,
		RiferimentiStudio,
		$modal) {

		var chPassModal = {
			animation: true,
			templateUrl: 'modules/common/view/modalChangePassword.tpl.html',
			controller: 'ModalChangePasswordController',
			size: "md"
		};
		$scope.changePassword = function($event) {
			chPassModal.backdrop = true;
			$modal.open(chPassModal);
			$event.stopPropagation();
		};
		$scope.forcePassword =  function() {
			chPassModal.backdrop = "static";
			chPassModal.keyboard = false;
			$modal.open(chPassModal);
		};

		$scope.canChangePassword = false;
		DatiCliente.getDenominazione().then(function(denominazione) {
			$scope.denominazione = denominazione;
			DatiCliente.canChangePassword().then(function(canChangePassword){
				$scope.canChangePassword = canChangePassword
				if (canChangePassword) {
					DatiCliente.mustChangePassword().then(function(force){
						if (force) {
							$scope.forcePassword();
						}
					});
				}
			});
		});

		$scope.clearSearch = function() {
			$scope.queryFascicoli = "";
		};

		$scope.onEnter = function() {
                    $state.go('fascicoli', {
                        'aliasStudio': $scope.aliasStudio,
                        'query': $scope.queryFascicoli
                    });
				};

        RiferimentiStudio.getDati().then(function(riferimentiStudio) {
			$scope.intestazionePrincipale =riferimentiStudio.intestazioneprincipale;
			$scope.intestazioneSecondaria =riferimentiStudio.intestazionesecondaria;
		
			RiferimentiStudio.hasLogo().then(function(logoExists) {
				if (logoExists) {
					RiferimentiStudio.getLogo().then(function(logo) {
						$scope.urlLogo = logo;
					});
				} else {
					$scope.urlLogo = "";
				}
			});

	});

		

	};

	return [
		"$scope",
		"$state",
		"Token",
		"DatiCliente",
		"RiferimentiStudio",
		"$modal",
		Controller
	];
});
